import { lazy } from 'react';

const LazyHelmet = lazy(async () => {
  const mod = await import('react-helmet');
  return { default: mod.Helmet };
});

export default LazyHelmet